import { render, staticRenderFns } from "./releaseadd.vue?vue&type=template&id=a07b9eb4&"
import script from "./releaseadd.vue?vue&type=script&lang=js&"
export * from "./releaseadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports